"use client";

import React, { useEffect, useState } from 'react'
import { FaBars } from 'react-icons/fa6';
import { IoIosClose } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
    
    const [isHovered, setIsHovered] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [scrollY, setScrollY] = useState(0); // Store scroll position in state
    const navigate = useNavigate()
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [showTerminalModal, setShowTerminalModal] = useState(false);
    const [credentialForm, setCredentialForm] = useState({ username: '', password: '' });
    const [requestForm, setRequestForm] = useState({ name: '', email: '', organization: '' });
    const [accessMessage, setAccessMessage] = useState('');
    const [telemetryLog, setTelemetryLog] = useState([]);
    useEffect(() => {
        const handleScroll = () => {
            const newScrollY = window.pageYOffset; // Get current scroll position
            setScrollY(newScrollY); // Update state with new scroll position
           

        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup function to remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

      // Store scroll position in state
      const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
          // Scroll to the section if it exists
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          // Redirect the user to the "Home" page
          navigate('/');
          
        }
        // Close the sidebar after scrolling
        setShowSidebar(false);
      };

    const handleSidebar = () => {
        setShowSidebar(!showSidebar)
    }

    useEffect(() => {
      document.body.classList.toggle('menu-open', showSidebar);

      return () => {
        document.body.classList.remove('menu-open');
      };
    }, [showSidebar]);
    const handleMouseEnter = (index) => {
      setHoveredIndex(index);
    };
  
    const handleMouseLeave = () => {
      setHoveredIndex(null);
    };

    const handleCredentialChange = (event) => {
      const { name, value } = event.target;
      setCredentialForm((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleRequestChange = (event) => {
      const { name, value } = event.target;
      setRequestForm((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleLogin = (e) => {
      e.preventDefault();
      console.log('ENV USER:', process.env.REACT_APP_TERMINAL_USERNAME);
      console.log('ENV PASS:', process.env.REACT_APP_TERMINAL_PASSWORD);

      const isValidUsername = credentialForm.username === process.env.REACT_APP_TERMINAL_USERNAME;
      const isValidPassword = credentialForm.password === process.env.REACT_APP_TERMINAL_PASSWORD;

      if (isValidUsername && isValidPassword) {
        document.cookie = 'terminal_access=true; path=/';
        localStorage.setItem('terminal_access', 'true');
        window.location.href = 'https://terminal.qlab.work';
      } else {
        setAccessMessage('Invalid credentials');
      }
    };

    const handleRequestSubmit = (event) => {
      event.preventDefault();
      console.log('Research terminal access request submitted:', requestForm);
      setAccessMessage('Access request received.');
      setRequestForm({ name: '', email: '', organization: '' });
    };

    const openTerminalModal = () => {
      setShowTerminalModal(true);
      setAccessMessage('');
      setShowSidebar(false);
    };

    const closeTerminalModal = () => {
      setShowTerminalModal(false);
      setAccessMessage('');
    };


    useEffect(() => {
      if (!showTerminalModal) {
        setTelemetryLog([]);
        return undefined;
      }

      const messages = [
        'BTCUSDT signal scan completed',
        'compression regime detected',
        'Engine B gating: PASS',
        'signal accepted',
        'expected R: 0.57',
        'ETHUSDT scan completed',
        'Engine B gating: REJECTED',
        'portfolio risk update',
        'active strategies: 4',
      ];

      const createTimestamp = () => {
        const now = new Date();
        return now.toTimeString().slice(0, 8);
      };

      let messageIndex = 0;

      const appendMessage = () => {
        const entry = `[${createTimestamp()}] ${messages[messageIndex]}`;
        messageIndex = (messageIndex + 1) % messages.length;

        setTelemetryLog((current) => {
          const next = [...current, entry];
          return next.slice(-120);
        });
      };

      appendMessage();
      const interval = window.setInterval(appendMessage, 2000);

      return () => window.clearInterval(interval);
    }, [showTerminalModal]);

    useEffect(() => {
      if (!showTerminalModal) {
        return undefined;
      }

      const handleEscape = (event) => {
        if (event.key === 'Escape') {
          closeTerminalModal();
        }
      };

      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }, [showTerminalModal]);

    useEffect(() => {
      if (!showTerminalModal) {
        return;
      }

      const telemetryElement = document.getElementById('telemetry');
      if (telemetryElement) {
        telemetryElement.scrollTop = telemetryElement.scrollHeight;
      }
    }, [telemetryLog, showTerminalModal]);

    const riskPercent = 4.2;
    const maxRiskPercent = 10;
    const riskSlots = 10;
    const filledSlots = Math.max(0, Math.min(riskSlots, Math.round((riskPercent / maxRiskPercent) * riskSlots)));
    const riskMeter = `${'■'.repeat(filledSlots)}${'□'.repeat(riskSlots - filledSlots)}`;

  return (
    <>
    <div className='header navbar flex justify-between items-center h-fit py-8 w-full max-w-screen-3xl'>
                        <Link to={'/'}><img src='/favicon.png' alt='logo' className='logo w-20 h-16' /></Link>
                        <div
                            className='menu-button flex gap-4 cursor-pointer items-center fixed top-5 right-5 md:top-8 md:right-16 z-[5] max-screen:right-40 text-white'
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={handleSidebar}
                        >
                            <span className={`tracking-[2px] ${scrollY >= 50 ? 'opacity-0 transition-opacity duration-500' : ''} ${isHovered ? 'text-primary-dark' : 'hover:text-primary-dark transition-colors duration-500'}`}>MENU</span>
                            <FaBars className='text-[40px] bg-black p-1 ' />
                        </div>
                    </div>
 {/* sidebar */}
 <div
            className={`menu-overlay ${showSidebar ? 'active' : ''}`}
        >
            <div className='menu-content px-6 py-8 md:px-10'>
            <div className='flex justify-center items-center text-text gap-2 relative'>
                <IoIosClose onClick={() => setShowSidebar(!showSidebar)} className='absolute right-0 justify-self-end bg-black text-2xl text-white rounded-full ' />
            </div>
            <div className='flex flex-col font-bold justify-self-start gap-1 pl-10 pr-6 text-primary-dark'>
                <span>Qlab</span>
                <span className='text-[10px] tracking-[1px] text-secondary-light'>Quantitative Research & Systematic Trading Infrastructure</span>
            </div>
            <ul className='flex flex-col pl-10 pr-6 mt-10'>
      <Link to={'/'}>
        <li
          onMouseEnter={() => handleMouseEnter(1)}
          onMouseLeave={handleMouseLeave}
          className='text-base cursor-pointer text-white flex gap-6 border-t py-4 border-b border-secondary-light'
          onClick={() => scrollToSection('home')}
        >
          <span className={`${hoveredIndex === 1 ? 'text-primary-dark' : 'text-secondary-light'} `}>01</span>Home
        </li>
      </Link>
      <li
        onMouseEnter={() => handleMouseEnter(2)}
        onMouseLeave={handleMouseLeave}
        className='text-base cursor-pointer text-white flex gap-6 py-4 border-b border-secondary-light'
        onClick={() => scrollToSection('research')}
      >
        <span className={`${hoveredIndex === 2 ? 'text-primary-dark' : 'text-secondary-light'} `}>02</span>Research
      </li>
      <li 
        onMouseEnter={() => handleMouseEnter(3)}
        onMouseLeave={handleMouseLeave}
        className='text-base cursor-pointer text-white flex gap-6 py-4 border-b border-secondary-light' onClick={() => scrollToSection('engines')}><span className={`${hoveredIndex === 3 ? 'text-primary-dark' : 'text-secondary-light'} `}>03</span>Research Infrastructure</li>
      <Link to={'/about-us'}>
        <li 
        onMouseEnter={() => handleMouseEnter(4)}
        onMouseLeave={handleMouseLeave}
        className='text-base cursor-pointer text-white flex gap-6 py-4 border-b border-secondary-light' onClick={() => scrollToSection('lab')}><span className={`${hoveredIndex === 4 ? 'text-primary-dark' : 'text-secondary-light'} `}>04</span>Lab</li>
      </Link>
      <li 
      
      onMouseEnter={() => handleMouseEnter(5)}
        onMouseLeave={handleMouseLeave}
        className='text-base cursor-pointer text-white flex gap-6 py-4 border-b border-secondary-light' onClick={() => scrollToSection('partnerships')}><span className={`${hoveredIndex === 5 ? 'text-primary-dark' : 'text-secondary-light'} `}>05</span>Partnerships</li>
      <li 
      onMouseEnter={() => handleMouseEnter(6)}
      onMouseLeave={handleMouseLeave}
      className='text-base cursor-pointer text-white flex gap-6 py-4 border-b border-secondary-light' onClick={() => scrollToSection('contact')}><span className={`${hoveredIndex === 6 ? 'text-primary-dark' : 'text-secondary-light'} `}>06</span>Contact</li>
      <Link to={'/terms-and-conditions'}>
        <li 
        onMouseEnter={() => handleMouseEnter(7)}
        onMouseLeave={handleMouseLeave}
        className='text-base cursor-pointer text-white flex gap-6 py-4 border-b border-secondary-light' ><span className={`${hoveredIndex === 7 ? 'text-primary-dark' : 'text-secondary-light'} `}>07</span>Terms</li>
      </Link>
      <div className='border-b border-white/20 mt-4 mb-3' />
      <li
        className='research-terminal-link cursor-pointer text-white py-2 transition-opacity duration-300 hover:opacity-100'
        onClick={openTerminalModal}
      >
        <p className='text-[14px] tracking-[1px] font-mono opacity-70'>🔒 Research Terminal</p>
        <p className='text-[11px] tracking-[1px] font-mono opacity-50'>Live Engine Monitor</p>
      </li>
    </ul>
    </div>
        </div>
        {showTerminalModal && (
          <div className={`terminal-overlay ${showTerminalModal ? 'active' : ''}`}>
            <div className='terminal-panel md:p-8'>
              <div className='mb-6 flex items-start justify-between gap-4 pr-12'>
                <div>
                  <h2 className='text-xl font-semibold md:text-2xl'>Research Terminal Access</h2>
                  <p className='mt-2 text-sm text-secondary-light'>
                    This console provides restricted access to the QLab live system monitor. Credentials are required to view real-time engine telemetry.
                  </p>
                </div>
                <button
                  type='button'
                  aria-label='Close modal'
                  className='overlay-close flex h-9 w-9 items-center justify-center text-[16px] text-secondary-light transition-colors duration-200 hover:text-white'
                  onClick={closeTerminalModal}
                >
                  ×
                </button>
              </div>

              <div className='grid gap-6 md:grid-cols-2'>
                <form className='border border-white/10 p-4' onSubmit={handleLogin}>
                  <h3 className='font-mono text-sm uppercase tracking-[1px] text-primary-dark'>Enter Credentials</h3>
                  <div className='mt-4 space-y-3'>
                    <input
                      name='username'
                      type='text'
                      value={credentialForm.username}
                      onChange={handleCredentialChange}
                      placeholder='Username'
                      className='w-full border border-white/10 bg-black px-3 py-2 font-mono text-sm text-white outline-none focus:border-white/40'
                      required
                    />
                    <input
                      name='password'
                      type='password'
                      value={credentialForm.password}
                      onChange={handleCredentialChange}
                      placeholder='Password'
                      className='w-full border border-white/10 bg-black px-3 py-2 font-mono text-sm text-white outline-none focus:border-white/40'
                      required
                    />
                  </div>
                  <button
                    type='submit'
                    className='mt-4 border border-white/20 px-3 py-2 font-mono text-sm tracking-[1px] text-white transition-colors duration-300 hover:border-white/60 hover:bg-white/10'
                  >
                    Access Terminal
                  </button>
                </form>

                <form className='border border-white/10 p-4' onSubmit={handleRequestSubmit}>
                  <h3 className='font-mono text-sm uppercase tracking-[1px] text-primary-dark'>Request Access</h3>
                  <div className='mt-4 space-y-3'>
                    <input
                      name='name'
                      type='text'
                      value={requestForm.name}
                      onChange={handleRequestChange}
                      placeholder='Name'
                      className='w-full border border-white/10 bg-black px-3 py-2 font-mono text-sm text-white outline-none focus:border-white/40'
                      required
                    />
                    <input
                      name='email'
                      type='email'
                      value={requestForm.email}
                      onChange={handleRequestChange}
                      placeholder='Email'
                      className='w-full border border-white/10 bg-black px-3 py-2 font-mono text-sm text-white outline-none focus:border-white/40'
                      required
                    />
                    <input
                      name='organization'
                      type='text'
                      value={requestForm.organization}
                      onChange={handleRequestChange}
                      placeholder='Organization (optional)'
                      className='w-full border border-white/10 bg-black px-3 py-2 font-mono text-sm text-white outline-none focus:border-white/40'
                    />
                  </div>
                  <button
                    type='submit'
                    className='mt-4 border border-white/20 px-3 py-2 font-mono text-sm tracking-[1px] text-white transition-colors duration-300 hover:border-white/60 hover:bg-white/10'
                  >
                    Submit Request
                  </button>
                </form>
              </div>

              <div className='mt-6'>
                <p className='text-[11px] uppercase tracking-[0.2em] text-[#FFFFFF80]'>Strategy Telemetry Feed</p>
                <div id='telemetry' className='terminal-log mt-3'>
                  {telemetryLog.map((entry, index) => (
                    <p key={`${entry}-${index}`} className='terminal-log-entry'>{entry}</p>
                  ))}
                </div>
              </div>

              <div className='terminal-risk-panel'>
                <p className='terminal-risk-title'>PORTFOLIO RISK</p>
                <p className='terminal-risk-line'>{riskMeter} {riskPercent.toFixed(1)}% of capital</p>
                <div className='terminal-risk-fields'>
                  <p>Active Strategies: 4</p>
                  <p>Signals Evaluated: 28</p>
                  <p>Portfolio Expectancy: +0.57R</p>
                </div>
              </div>

              {accessMessage && <p className='mt-6 font-mono text-sm text-primary-dark'>{accessMessage}</p>}
              {/* This modal will eventually authenticate and redirect
              to the QLab research dashboard (internal terminal interface) */}
            </div>
          </div>
        )}
                    </>
  )
}

export default Navbar
